import { DialogContent, DialogOverlay } from '@reach/dialog';
import * as React from 'react';
import { animated, useTransition } from 'react-spring';
import { useLazyRef } from '../hooks/use-lazy-ref';

type SidebarProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export const Sidebar = (props: SidebarProps) => {
  const OverlayRef = useLazyRef(() => animated(DialogOverlay));
  const ContentRef = useLazyRef(() => animated(DialogContent));
  const transitions = useTransition(props.open, null, {
    from: {
      opacity: 0,
      left: '-100%',
    },
    enter: {
      opacity: 1,
      left: '0',
    },
    leave: {
      opacity: 0,
      left: '-100%',
    },
  });
  const Overlay = OverlayRef.current;
  const Content = ContentRef.current;

  return (
    <>
      {transitions.map(
        ({ item, key, props: styles }) =>
          item && (
            <Overlay
              style={{ opacity: styles.opacity }}
              onDismiss={props.onClose}
              key={key}
            >
              <Content
                style={{
                  transform: styles.left!.interpolate(
                    value => `translateX(${value})`
                  ),
                }}
                className="w-auto h-full m-0 p-0 max-w-xs inline-block"
                aria-label="Menu"
              >
                {props.children}
              </Content>
            </Overlay>
          )
      )}
    </>
  );
};
